var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgClearAll1 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7.222,
    viewBox: "0 0 13 7.222",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,21.222V20.139H16.111v1.083Zm1.444-3.069V17.069H17.556v1.083Zm1.444-3.069V14H19v1.083Z",
    transform: "translate(-6 -14)",
    fill: "#3953fb"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClearAll1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clearAll1.d0a3c951.svg";
export { ForwardRef as ReactComponent };